import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,
        DownloadTemplate,DynamicListArea,BulkEdit,
        LoadGraphic,AddListItem,Step,Dropzone} from '../components/Common';
import {Input,TextButton,Button,InputPhoto,MiniMinusButton} from '../components/Input';
import u from '../utilities/Utilities';
import {Attachment} from '../data/Mimetypes';
import moment from 'moment';

export default class TraitList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Trait List",
        permission:"trait",  //Accepts combined permission module as well
        //combinedField:"",          //Used when permission exists in a combined field
        url:"/trait-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/add-trait-entry",
        templateURL:"/api/get-add-trait-template",
        bulkURL:"/api/add-bulk-trait-entries",
        deleteURL:"/api/delete-trait-entries",
        spreadsheetURL:"/api/generate-trait-spreadsheet",
        overviewURL:"/api/get-all-trait-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"trait-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        download:{component:DownloadTemplate,props:{skipParams:true}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:(permissions.create==2)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ]
        })
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu ref={(ref)=>{this.r['pageMenu']=ref}}
                          buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index}
                                          index={index}
                                          content={content}
                                          onChange={onChange}
                                          onContentChange={onContentChange}
                                          registerReference={registerRef}
                                          permissions={this.state.permissions}
                                          settings={this.settings}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{

    state={
        error:"",
        step:"view",
        loading:false,
        loadText:"",
    };

    render=()=>{
        const {content,settings,permissions} = this.props;
        const canEdit= (permissions.update==2);

        return (
            <div style={{textAlign:"center"}}>

                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={this.state.step=="view"}>
                    <DynamicListArea listLabel={settings.listLabel}
                                    permission={settings.permission}
                                    content={content}
                                    onChange={this.props.onChange}
                                    index={this.props.index}
                                    />
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{

    settings={
        addType:0,
        addURL:"/api/add-trait-entry",
        templateURL:"/api/get-add-trait-template",
        bulkURL:"/api/add-bulk-trait-entries",
    };

    r={};

    state={
        step:"add",
        entryData:{},
        options:{},
        traitCategory:[],
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:""});
        }
    }

    componentDidMount=()=>{
        this.getOptions();
        this.getTraitCategories();
        this.show(this.props.active);
    }

    getOptions=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-options",
                data:{
                    keys:[
                        "traitType"
                    ]
                }
            });

            this.setState({options:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    getTraitCategories=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-trait-categories-options",
            });
            this.setState({traitCategory:response.data.map((item)=>{
                return item.value
            })});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirm=(fields)=>{
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        const {entryData}=this.state;
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onValidated({...entryData,...data});
    }

    onComplete=()=>{
        this.setState({
            entryData:{},
            step:"add"
        });

        if(this.props.onComplete){
            this.props.onComplete();
        }
    }

    onChange=(value,label,index)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onBulkUpload=()=>{
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onBulkUpload()
    }

    render=()=>{
        const {loading,loadText,step,options,entryData,traitCategory}=this.state;

        const fields=[
            {dataType:"box",label:"Trait Title",field:"traitTitle",rules:{required:true}},
            {dataType:"box",label:"Category",field:"category",rules:{required:true,list:traitCategory},style:{zIndex:1}},
            {dataType:"select",label:"Type",field:"traitType",options:options.traitType,rules:{required:true}},
        ];

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={false}
                         inList={this.props.miniList}
                         onToggleForm={this.props.onToggleForm}
                         >

                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="add"}>
                        <h3>Complete the following fields to create entry</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                    options:item.options,
                                                    value:entryData[item.field]
                                               }}
                                               fields={{
                                                ...item,
                                                onChange:this.onChange
                                               }}
                                               rules={item.rules}
                                               style={item.style}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }
                        <div style={{margin:"20px auto",fontSize:"14px"}}>
                            <TextButton onClick={this.onBulkUpload}>Bulk Upload</TextButton>
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirm(fields)}}>Confirm</Button>
                        </div>
                    </Step>
                </div>

            </AddListItem>
        )
    }
}
